import { StorefrontLinkPostInput } from '../../templates/inputs/StorefrontLinkPostInput';
import {
    ActionButton,
    DEFAULT_OPEN_IN_STORE_ACTION,
    getDefaultButton,
    isButtonType,
    OpenInStoreAction,
} from '../components/ActionButton';
import { ArticlePage } from '../components/ArticlePage';
import { isArticlePost } from '../PostTypes';
import { ArticlePostData } from '../types/ArticlePostType';
import { defineTemplate } from './TemplateUtils';

import { RequiredField } from '../../../types/requiredField';

export type StorefrontLinkPage = RequiredField<ArticlePage, 'button'> & {
    button: ActionButton & { action: OpenInStoreAction };
};

export type StorefrontLinkPostData = Omit<ArticlePostData, 'pages'> & {
    pages: [StorefrontLinkPage];
};

export const isStorefrontLinkPage = (
    value: ArticlePage,
): value is StorefrontLinkPage => {
    return (
        value.button !== undefined && isButtonType(value.button, 'OpenInStore')
    );
};

export const isStorefrontLinkPost = (
    value: unknown,
): value is StorefrontLinkPostData => {
    return (
        isArticlePost(value) &&
        value.pages.length === 1 &&
        isStorefrontLinkPage(value.pages[0])
    );
};

export const StorefrontLinkMedium = defineTemplate(
    'Article',
    'Medium',
    StorefrontLinkPostInput,
    () =>
        ({
            $type: 'Article',
            size: 'Medium',
            pages: [
                {
                    button: getDefaultButton(DEFAULT_OPEN_IN_STORE_ACTION),
                },
            ],
        }) satisfies StorefrontLinkPostData,
    isStorefrontLinkPost,
);
export const StorefrontLinkLarge = defineTemplate(
    'Article',
    'Large',
    StorefrontLinkPostInput,
    () =>
        ({
            $type: 'Article',
            size: 'Large',
            pages: [
                {
                    button: getDefaultButton(DEFAULT_OPEN_IN_STORE_ACTION),
                },
            ],
        }) satisfies StorefrontLinkPostData,
    isStorefrontLinkPost,
);
